import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface NavItem {
  label: string;
  icon: React.ReactNode;
  path: string;
  tabKey: string;
}

const navItems: NavItem[] = [
  {
    label: "Home",
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 28 28">
        <path
          d="M4 12.5L14 5l10 7.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 12.5V22a1.5 1.5 0 001.5 1.5h4.5v-5h4v5H21a1.5 1.5 0 001.5-1.5v-9.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    path: "/home",
    tabKey: "dashboard",
  },
  {
    label: "Track",
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 28 28">
        <circle cx="14" cy="14" r="10" stroke="currentColor" strokeWidth="2" />
        <path
          d="M14 9v5l3 3"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
    path: "/order/track",
    tabKey: "track",
  },
  {
  label: "New",
  icon: (
    <svg width="50" height="50" fill="none" viewBox="0 0 28 28">
      <circle cx="14" cy="14" r="10" stroke="#44B6CE" strokeWidth="2" />
      <path
        d="M14 10V18M10 14H18"
        stroke="#44B6CE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  path: "/order/new",
  tabKey: "track",
},
  {
    label: "History",
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 28 28">
        <rect
          x="6"
          y="8"
          width="16"
          height="12"
          rx="2"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M10 12h8M10 16h5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
    path: "/order/history",
    tabKey: "history",
  },
  {
    label: "Profile",
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 28 28">
        <circle cx="14" cy="10" r="4" stroke="currentColor" strokeWidth="2" />
        <path
          d="M6 22c0-3.314 3.134-6 7-6s7 2.686 7 6"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    ),
    path: "/profile",
    tabKey: "profile",
  },
];

interface BottomNavBarProps {
  customActiveTab?: string;
  onTabChange?: (tabKey: string) => void;
  isHomeScreen?: boolean;
}

export default function BottomNavBar({
  customActiveTab,
  onTabChange,
  isHomeScreen,
}: BottomNavBarProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (item: NavItem) => {
    if (isHomeScreen && onTabChange) {
      onTabChange(item.tabKey);
    } else {
      navigate(item.path);
    }
  };

  const getActive = (item: NavItem): boolean => {
    if (isHomeScreen && customActiveTab) {
      return customActiveTab === item.tabKey;
    }
    return location.pathname === item.path;
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 w-full bg-[#F7F9FB] border-t border-gray-200 z-50 pb-[env(safe-area-inset-bottom)]">
      <div className="flex justify-between items-end px-2 pt-2 pb-3">
        {navItems.map((item) => (
          <div
            key={item.label}
            className="flex flex-col items-center flex-1"
            onClick={() => handleClick(item)}
            style={{ cursor: "pointer" }}
          >
            <div
              className={`mb-1 ${
                getActive(item) ? "text-[#3CB3D6]" : "text-[#475569]"
              }`}
            >
              {item.icon}
            </div>
            <span
              className={`text-xs ${
                getActive(item) ? "text-[#3CB3D6]" : "text-[#475569]"
              }`}
            >
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </nav>
  );
}